import { Button, withStyles, DialogActions } from '@material-ui/core';
import Events from '../../../../../../../utilities/EventEmitter';
import { compose } from 'recompose';

const styles = (theme) => ({
  dialogFooter: {
    padding: '10px 100px',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  actionButton: {
    margin: '0 -4 0 16',
    minWidth: '136px',
    '&$disabledButton': {
      backgroundColor: theme.disabledColor,
      color: theme.TextColor,
      opacity: 0.8
    }
  },
  disabledButton: {}
});

const Action = (props) => {
  const {
    classes,
    pickupInfo,
    pickInfoStateData,
    isEditPickupActionDisabled,
    handleClose,
    resizePickInfoClass
  } = props;
  const isGroupPickupDialog = Boolean(pickInfoStateData?.isGroupPickupDialog);
  const groupBulkEditPickupIds = pickInfoStateData?.groupBulkEditPickupIds;
  const editPickup = () => {
    handleClose();
    if (isGroupPickupDialog && groupBulkEditPickupIds?.length) {
      Events.emit('EditPickup', { bulkPickupIds: groupBulkEditPickupIds });
      return;
    }
    Events.emit('EditPickup', pickupInfo.pickupId);
  };
  return (
    <DialogActions className={`${classes.dialogFooter} ${resizePickInfoClass}`}>
      <Button
        onClick={editPickup}
        color="primary"
        variant="contained"
        className={classes.actionButton}
        classes={{
          root: classes.actionButton,
          disabled: classes.disabledButton
        }}
        disabled={isEditPickupActionDisabled}>
        {isGroupPickupDialog ? 'Group Edit' : 'Edit'}
      </Button>
      <Button
        onClick={handleClose}
        color="primary"
        variant="outlined"
        className={classes.actionButton}>
        Close
      </Button>
    </DialogActions>
  );
};

export default compose(withStyles(styles))(Action);
